import React from 'react';
import { Container, Grid, Header, Image } from 'semantic-ui-react';
import Form from './Form';
import Logo from '../assests/logo.png';
import MainMenu from './Menu';

const Event = () => {
	return (
		<>
			<MainMenu attached />
			<Container text className="mb-40 mt-40">
				<Grid stackable>
					<Grid.Row columns={1}>
						<Grid.Column>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									marginBottom: '10px',
								}}
							>
								{/* <Image
									src={Logo}
									style={{ marginRight: '10px', width: '40px' }}
								/> */}
								<div>
									<div style={{ fontWeight: 'bold' }}>
										Gobierno de Puerto Rico
									</div>
									<div>
										Administración de Servicios de Salud Mental y Contra la
										Adicción
									</div>
								</div>
							</div>
							<div className="clearfix" />
							<Header as="h1">
								Eventos
								<Header.Subheader>
									Formulario de Eventos y Respuesta a Sobredosis por Consumo de
									Drogas
								</Header.Subheader>
							</Header>
							<p className="small justify">
								La ASSMCA desarrolló este formulario con el propósito de
								documentar{' '}
								<span className="strong">
									{' '}
									los eventos sobredosis por consumo de drogas y el uso de
									naloxona
								</span>{' '}
								en dichos eventos. Se recoge información de la persona afectada,
								detalles del evento de la posible sobredosis y el tipo de
								servicios que fueron ofrecidos. Favor de seleccionar la opción
								que mejor represente su respuesta. Algunas de preguntas pueden
								contener más de una respuesta, seleccione todas las que
								apliquen.{' '}
								<span className="orange strong">
									Los asteriscos (*) denotan que la información solicitada es
									requerida.
								</span>
							</p>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row columns={1}>
						<Grid.Column>
							<Form />
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</Container>
		</>
	);
};

export default Event;
